













import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "PreviewSetButton",
  components: { BaseButton, BaseIcon },
  props: {
    public: { type: Boolean, required: true },
    wrapperStyle: {
      type: Object as () => Record<string, string>,
      default: () => ({ width: "max(min(6vw, 40px), 28px)", height: "max(min(6vw, 40px), 28px)" }),
    },
    iconSize: { type: String, default: "max(min(3vw,20px), 13px)" },
  },
});
